import { apiFetchAccounts } from './apiAccounts';
import type { UserReportPreview, UserReportFull, CreateReportBody } from '../types/report';

/**
 * List user's reports with pagination
 */
export async function listReports(limit: number = 100): Promise<UserReportPreview[]> {
  return apiFetchAccounts(`/reports?limit=${limit}`);
}

/**
 * Get a specific report by ID
 */
export async function getReport(id: string): Promise<UserReportFull> {
  return apiFetchAccounts(`/reports/${id}`);
}

/**
 * Create a new report
 */
export async function createReport(body: CreateReportBody): Promise<{ id: string }> {
  return apiFetchAccounts('/reports', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

/**
 * Delete a report by ID
 */
export async function deleteReport(id: string): Promise<void> {
  await apiFetchAccounts(`/reports/${id}`, {
    method: 'DELETE',
  });
}

/**
 * Clear all reports for the current user
 */
export async function clearReports(): Promise<void> {
  await apiFetchAccounts('/reports', {
    method: 'DELETE',
  });
}
